import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { LOCATION_PAGES } from "@/lib/constants";

export default function Footer() {
  const { settings } = useApp();
  const phone = settings?.phone || "9325271272";
  const email = settings?.email || "info@endeavourcastle.com";

  return (
    <footer data-testid="site-footer" className="bg-primary text-primary-foreground mt-24">
      <div className="ec-container py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <span className="h-9 w-9 rounded-sm bg-accent text-accent-foreground grid place-items-center font-display text-lg">E</span>
            <span className="font-display text-xl">Endeavour Castle</span>
          </div>
          <p className="text-sm text-primary-foreground/70 leading-relaxed">
            A Pune-focused real-estate discovery and advisory platform helping you find the right residential and commercial property with expert guidance.
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-[0.16em] text-accent mb-4">Explore</h4>
          <ul className="space-y-2.5 text-sm text-primary-foreground/75">
            <li><Link to="/properties" className="hover:text-white transition-colors">Properties</Link></li>
            <li><Link to="/projects" className="hover:text-white transition-colors">Projects</Link></li>
            <li><Link to="/locations" className="hover:text-white transition-colors">Locations</Link></li>
            <li><Link to="/guides" className="hover:text-white transition-colors">Buyer Guides</Link></li>
            <li><Link to="/compare" className="hover:text-white transition-colors">Compare & Shortlist</Link></li>
            <li><Link to="/requirements" className="hover:text-white transition-colors">Tell Us Your Requirement</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-[0.16em] text-accent mb-4">Popular Areas</h4>
          <ul className="space-y-2.5 text-sm text-primary-foreground/75">
            {LOCATION_PAGES.slice(0, 6).map((l) => (
              <li key={l.slug}><Link to={`/locations/${l.slug}`} className="hover:text-white transition-colors">Property in {l.name}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-[0.16em] text-accent mb-4">Get in Touch</h4>
          <ul className="space-y-3 text-sm text-primary-foreground/75">
            <li><a href={`tel:${phone}`} className="flex items-center gap-2 hover:text-white transition-colors"><Phone className="h-4 w-4" aria-hidden /> {phone}</a></li>
            <li><a href={`mailto:${email}`} className="flex items-center gap-2 hover:text-white transition-colors"><Mail className="h-4 w-4" aria-hidden /> {email}</a></li>
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4" aria-hidden /> {settings?.address || "Pune, Maharashtra, India"}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="ec-container py-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-primary-foreground/60">
          <p>© {new Date().getFullYear()} Endeavour Castle. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white transition-colors">Terms</Link>
            <Link to="/rera-disclaimer" className="hover:text-white transition-colors">RERA Disclaimer</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
